import {Checkmark, Close} from '@carbon/icons-react';
import React from 'react';

type Props = {
    passed: boolean;
    showText?: boolean;
}

export default function ComplianceIndicator(props: Props) {
    const {passed, showText} = props;
    return <div className="flex items-center gap-2">
        <div className={`w-4 h-4 text-white rounded-full flex justify-center items-center ${passed ? 'bg-blue-500' : 'bg-red-500'}`}>
            {passed ? <Checkmark size={12} data-testid='checkmark-icon'/> : <Close size={12} data-testid='close-icon'/>}
        </div>
        {showText && <span className="text-gray-700 text-sm font-normal">{passed ? 'Pass' : 'Fail'}</span>}
    </div>;
}